























































































































import { Component, Vue } from "vue-property-decorator";
import copyUrl from "@/components/copyUrl.vue";
@Component({
  components: {
    copyUrl,
  },
})
export default class Manager extends Vue {
  // export default {
  public data() {
    return {
      tableData: [],
      actStatus: ["创建中", "未发布", "暂停", "未开始", "结束", "进行中"],
      loading: false,
      total: 0,
      copyInfo: {
        show: false,
        url: "",
      },
      parmas: {
        name: "",
        page_size: 10,
        page: 1,
        activity_id: 14,
      },
    };
  }

  public async created() {
    this.queryList();
  }

  public queryListName() {
    this.$data.parmas.page = 1;
    this.queryList();
  }
  /**
   * 列表查询
   */
  public async queryList() {
    const { parmas } = this.$data;
    this.$data.loading = true;
    try {
      const dataList = await this.$store.dispatch("getTableList", parmas);
      this.$data.tableData = dataList.list;
      this.$data.total = dataList.total;
      this.$data.loading = false;
    } catch (error) {
      this.$data.loading = false;
      (this as any).$message.error(error.msg || error.message || error);
    }
  }

  /**
   * 单页面显示条数切换
   */
  public onPageSizeChange(e: any) {
    this.$data.parmas.page_size = e;
    this.queryList();
  }
  /**
   * 切换当前页
   */
  public onChange(e: any) {
    this.$data.parmas.page = e;
    this.queryList();
  }

  public create() {
    this.$router.push({ path: "/create/1" });
  }

  public async operation(event: string, id: number) {
    this.$data.loading = true;
    try {
      await this.$store.dispatch(event, {
        activity_instance_id: id,
      });
      this.queryList();
    } catch (error) {
      this.$data.loading = false;
      (this as any).$message.error(error.msg || error.message || error);
    }
  }
  /**
   * 下拉选择器
   * command 类型
   */
  public async handleClick(command: string, row: any) {
    switch (command) {
      case "onPublish":
        this.operation("onPublish", row.$attrs.data_id);
        break;
      case "onCopy":
        this.$data.copyInfo.show = true;
        this.$data.copyInfo.url = row.$attrs.data_url;
        break;
      case "onPaused":
        this.operation("onPaused", row.$attrs.data_id);
        break;
      case "onEnd":
        this.operation("onEnd", row.$attrs.data_id);
        break;
      case "goRecords":
        this.$router.push({ path: `/records/${row.$attrs.data_id}` });
        break;
      case "goStatics":
        console.log(this.$store.state.userInfo);
        const { merchant_num } = this.$store.state.userInfo;
        // this.$router.push({ path: `/statics/${row.$attrs.data_id}` });
        // "https://test-s3.enbrands.com/custom-reports/combination_purchase_prod.html#/waterfall?actId=" + row.$attrs.data_id,
        window.open(
          "https://cheaper-pack-jdapp.zkyai.com/custom-reports/combination_purchase_prod.html#/waterfall?actId=" +
            row.$attrs.data_id +
            "&merchantNum=" +
            merchant_num,
          "_blank"
        );
        break;
      case "goEdit":
        const { status, id } = row.$attrs.data;
        if (status == "5") {
          (this as any)
            .$confirm(
              "当前活动正在进行，编辑时活动会暂停，编辑后需要重新发布活动"
            )
            .then(async () => {
              await this.operation("onPaused", id);
              this.$router.push({ path: `/create/2/1/${id}` });
            })
            .catch((error: any) => {
              console.log(error);
            });
        } else {
          this.$router.push({ path: `/create/2/1/${id}` });
        }

        break;
      case "onDelete":
        (this as any)
          .$confirm("如果该活动已经发布，活动删除后，您将无法在列表中找到它")
          .then(() => {
            this.operation("onDelete", row.$attrs.data_id);
          })
          .catch(() => {});

        break;
      default:
        break;
    }
  }
}
